module.exports = __webpack_public_path__ + "img/landkarte_px.180f748a.png";